import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import AlertSection from '../alert-section/alert-section.component'

const FirstSessionAlert = ({ firstName }) => {
  const { t } = useTranslation(['checkIn'])

  return (
    <AlertSection
      type="firstSession"
      title={t('checkIn:firstSession')}
      description={t('checkIn:firsSessionLocation', { firstName })}
    />
  )
}

FirstSessionAlert.propTypes = {
  firstName: PropTypes.string.isRequired,
}

export default FirstSessionAlert
